import { FeatureToggle } from '@hkm/shared/enum/featureToggle';

export const TaskManagementFeatureToggles: Set<FeatureToggle> = new Set<FeatureToggle>()
  .add(FeatureToggle.TaskManagement);



// WEBPACK FOOTER //
// ./src/components/TaskManagement/shared/config/taskManagementFeatureToggles.ts